import axios from "../AuthAPI/auth-request-api";
import { pics } from "@/config/host.config";
import { AxiosError, AxiosRequestConfig } from "axios";

export async function deleteElement(id: string, url: string): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    axios
      .delete(url + "/" + id)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.status);
        }
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}

export async function deleteImages(
  name: string,
  path: string,
  url: string = pics.upload
): Promise<string> {
  const config: AxiosRequestConfig = {
    params: {
      path: path,
      name: name,
    },
  };
  return new Promise<string>((resolve, reject) => {
    console.log(url);
    axios
      .delete(url, config)
      .then((result) => {
        if (result.status === 200) {
          console.log("200");
          resolve(result.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function reestablishElement(
  id: string,
  url: string
): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    axios
      .put(url + "/" + id)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
